import MaisAtacado from "./MaisAtacado";
import qs from "qs"

const getFaturamento = (filter, {sz,pg}) =>
  MaisAtacado.get(`/v1/faturamento?${qs.stringify({sz,pg,...filter})}`);

const Faturamento = { getFaturamento };
export default Faturamento;